export enum TabId {
  FLOORPLANS = "FLOORPLANS",
  IMAGES = "IMAGES",
  FILES = "FILES",
  PRODUCT_LIST = "PRODUCT_LIST",
  INFORMATION = "INFORMATION",
  COLLABORATION = "COLLABORATION",
  CHECKLIST = "CHECKLIST",
}
